module.exports = __webpack_public_path__ + "static/media/Template-Stamps.com.fe4bc028.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/modules/channel/pages/Template-Stamps.com.svg
// module id = 3828
// module chunks = 0